import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import KycTable from './Kyc_table';
import { Button, Grid, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import SubCard from 'ui-component/cards/SubCard';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs() {
  const [value, setValue] = React.useState(0);

  const [SearchFilter, setSearchFilter] = useState({ name: "", agcode: "" })

  const handleFilterchange = (name, value) => {
    if (name === "name" && /^[a-zA-Z\s]*$/.test(value)) {

      setSearchFilter({ ...SearchFilter, [name]: value })
    }
    if (name === 'agcode' && /^[a-zA-Z0-9]*$/.test(value)) {
      setSearchFilter({ ...SearchFilter, [name]: value })
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleFilterClear = () => {
    setSearchFilter({ name: "", agcode: "" })
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <SubCard>
          <Grid container mb={1} gap={2} alignItems='center'>
            <Grid item xl={3} lg={3} md={6} sm={6}>
              <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600} >Name</Typography>
              <TextField
                id="outlined-basic"
                value={SearchFilter.name}
                fullWidth
                onChange={(e) => handleFilterchange("name", e.target.value)}
                size='small'
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: '2px solid #A9A9A980 50%', // change border color
                    borderRadius: '8px',
                  },
                  '& fieldset': {
                    borderColor: '#A9A9A980',
                    borderRadius: '8px'// default border color
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                variant="outlined" />
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6}>
              <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600} >Agent Code</Typography>
              <TextField
                id="outlined-basic"
                value={SearchFilter.agcode}
                fullWidth
                size='small'
                onChange={(e) => handleFilterchange("agcode", e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: '2px solid #A9A9A980 50%', // change border color
                    borderRadius: '8px',
                  },
                  '& fieldset': {
                    borderColor: '#A9A9A980',
                    borderRadius: '8px'// default border color
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                variant="outlined" />
            </Grid>
            <Grid item xl={1} lg={1} md={1} sm={12} mt={3}>
              <Button sx={{
                backgroundColor: "#688B2A",
                color: "#fff",
                borderRadius: "10px",
                '&:hover': {
                  backgroundColor: "#688B3A",
                  color: "#fff",
                  borderRadius: "10px",
                },
              }} fullWidth variant='outlined' onClick={() => handleFilterClear()}>clear</Button>
            </Grid>
          </Grid>
        </SubCard>
      </Grid>

      <Grid item xs={12} mt={1}>
        <SubCard>
          <Box sx={{ bgcolor: 'background.paper', height: '100%', width: '100%' }}>
            <Tabs
              indicatorColor='secondary'
              textColor='secondary'
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              sx={{ borderRight: 1, borderColor: 'divider' }}
            >
              <Tab label="Pending" {...a11yProps(0)} />
              <Tab label="Approved" {...a11yProps(1)} />
              <Tab label="OPS rejected" {...a11yProps(2)} />

            </Tabs>
            <div style={{ width: '100%' }}>
              <TabPanel value={value} index={0} sx={{ width: '100%' }}>
                <KycTable sx={{ width: '100vw' }} type={"pending"} filter={SearchFilter} />
              </TabPanel>
              <TabPanel value={value} index={1} sx={{ width: '100%' }} >
                <KycTable sx={{ width: '100vw' }} type={"approved"} filter={SearchFilter} />
              </TabPanel>
              <TabPanel value={value} index={2} sx={{ width: '100%' }}>
                <KycTable sx={{ width: '100vw' }} type={"rejected"} filter={SearchFilter} />
              </TabPanel>
            </div>
          </Box>
        </SubCard>
      </Grid>
    </Grid>

  );
}
